/**
 * Keyboard shortcuts help modal.
 *
 * Listens for the `tc:open-shortcuts-help` window event (fired by the
 * `?` shortcut in `KeyboardShortcuts.js`) and lists every shortcut the
 * app supports. The row rendering is in `ShortcutRow.js` so the
 * visual-edits Babel plugin doesn't hit its nested-map crash.
 */
import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import ShortcutRow from './ShortcutRow';

const isMac = typeof navigator !== 'undefined' && /Mac|iPod|iPhone|iPad/.test(navigator.platform);
const MOD = isMac ? '⌘' : 'Ctrl';

const SHORTCUTS = [
  { keys: [MOD, 'B'], label: 'Toggle sidebar' },
  { keys: [MOD, 'K'], label: 'Open global search' },
  { keys: [MOD, 'N'], label: 'Create new trip' },
  { keys: [MOD, 'L'], label: 'Create new lead' },
  { keys: ['N'], label: 'Create new trip (when not in a text field)' },
  { keys: ['?'], label: 'Show this help' },
];

const ShortcutsHelpDialog = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener('tc:open-shortcuts-help', handler);
    return () => window.removeEventListener('tc:open-shortcuts-help', handler);
  }, []);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-md" data-testid="shortcuts-help-dialog">
        <DialogHeader>
          <DialogTitle>Keyboard shortcuts</DialogTitle>
        </DialogHeader>
        <ul className="divide-y divide-slate-100 mt-2">
          {SHORTCUTS.map((s, idx) => (
            <ShortcutRow key={idx} label={s.label} keys={s.keys} idx={idx} />
          ))}
        </ul>
      </DialogContent>
    </Dialog>
  );
};

export default ShortcutsHelpDialog;
